import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  style: {"margin-bottom":"10px"},
  class: "grid ml-0 mr-1"
}
const _hoisted_3 = { class: "flex flex-auto p-input-icon-left p-input-icon-right mt-1" }
const _hoisted_4 = { class: "col-12 property-service-item hover-row" }
const _hoisted_5 = { class: "grid flex-nowrap" }
const _hoisted_6 = { class: "col-3 ml-4 compass-red" }
const _hoisted_7 = { class: "col-3 compass-red" }
const _hoisted_8 = { class: "col-3" }
const _hoisted_9 = { class: "col-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DataView = _resolveComponent("DataView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "grid" }, [
      _createElementVNode("div", { class: "col" }, [
        _createElementVNode("h4", null, "Users")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("i", { class: "pi pi-home" }, null, -1)),
        _createVNode(_component_InputText, {
          modelValue: _ctx.userSearchFilter,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userSearchFilter) = $event)),
          placeholder: "Service keyword filter.."
        }, null, 8, ["modelValue"]),
        _cache[2] || (_cache[2] = _createElementVNode("i", { class: "pi pi-search" }, null, -1))
      ]),
      _createVNode(_component_Button, {
        icon: "pi pi-plus",
        label: "New",
        onClick: _ctx.newUser,
        class: "p-button-rounded ml-1 md:ml-2 mt-1"
      }, null, 8, ["onClick"])
    ]),
    _createVNode(_component_DataView, {
      value: _ctx.filteredUsers,
      datakey: "loginId",
      paginator: true,
      rows: 100,
      scrollable: true,
      stripedRows: "",
      class: "p-datatable-sm",
      paginatorTemplate: _ctx.paginatorTemplate,
      rowsPerPageOptions: [10,20,50,100,200],
      responsiveLayout: "scroll",
      alwaysShowPaginator: false,
      currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
    }, {
      header: _withCtx(() => [...(_cache[3] || (_cache[3] = [
        _createElementVNode("div", { class: "col-12" }, [
          _createElementVNode("div", { class: "grid flex-nowrap" }, [
            _createElementVNode("div", { class: "col-3" }, "ID"),
            _createElementVNode("div", { class: "col-3" }, "Email"),
            _createElementVNode("div", { class: "col-3" }, "Access roles"),
            _createElementVNode("div", { class: "col-3" }, "Last Login")
          ])
        ], -1)
      ]))]),
      list: _withCtx(({data}) => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: { name: 'UserDetails', params: { loginId: data.loginId }}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(data.loginId), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: { name: 'UserDetails', params: { loginId: data.loginId }}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(data.loginEmail), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.formattedRoles(data.accessRoles)), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.formattedDate(data.whenLastLogin)), 1)
          ])
        ])
      ]),
      empty: _withCtx(() => [...(_cache[4] || (_cache[4] = [
        _createElementVNode("div", { class: "text-center pt-2 pb-2" }, " No records found. ", -1)
      ]))]),
      _: 1
    }, 8, ["value", "paginatorTemplate"])
  ]))
}